import React from 'react';
import { useQuery } from '@apollo/react-hooks';

import {
    branchDetail,
    branchDetail_branchDetail,
    branchDetail_branchDetail_opening_hours,
    branchDetailVariables,
} from '../../queries/__generated__/branchDetail';
import branchDetailQuery from '../../queries/getBranchDetail.graphql';
import { ErrorOrOfflineConnected } from '../Error/ErrorOrOffline';
import { Spinner } from '../Layout/Spinner';

export type BranchDetail = {
    url: string;
    address: string;
    bank_holiday_hours: string;
    city: string;
    latitude: string;
    longitude: string;
    name: string;
    opening_hours: (branchDetail_branchDetail_opening_hours | null)[];
    phone: string;
    special_services: (string | null)[];
    state: string | null;
    meta_title: string;
    meta_description: string;
    meta_keywords: string;
};

type BranchViewQueryProps = {
    name: string;
    render(params: { detail?: BranchDetail; loading: boolean });
};

export function BranchViewQuery(props: BranchViewQueryProps) {
    const { error, loading, data } = useQuery<branchDetail, branchDetailVariables>(branchDetailQuery, {
        variables: { name: props.name },
    });
    if (error) return <ErrorOrOfflineConnected />;
    if (loading) return <Spinner />;

    return props.render({
        loading,
        detail:
            (data &&
                Array.isArray(data.branchDetail) &&
                data.branchDetail[0] &&
                cleanDetail(data.branchDetail[0] as branchDetail_branchDetail)) ||
            undefined,
    });
}

export function cleanDetail(detail: branchDetail_branchDetail): BranchDetail {
    return {
        ...detail,
        phone: detail.phone ?? '',
        meta_title: detail.meta_title || detail.name || '',
        meta_description: detail.meta_description || detail.name || '',
        meta_keywords: detail.meta_keywords || detail.name || '',
    };
}
